import React from 'react';
import { motion } from 'framer-motion';
import './PrinciplesSection.css';

function PrinciplesSection() {
  const isIOSSafari = typeof document !== 'undefined' && document.documentElement.classList.contains('ios-safari');
  const inViewViewport = isIOSSafari ? { once: true, amount: 0.25 } : { once: true, amount: 0.15 };

  const principles = [
    {
      title: 'Lead growth is more important than customization',
      description: 'Google and the big brands have shaped how everyone searches online. We take their best practices and give them to you. This is why we outperform competitors who choose customization over results.'
    },
    {
      title: 'We have to earn your business every month',
      description: 'Running a business is hard enough - you don\'t need another tech vendor tying you up in contracts. You should be able to leave easily if we aren\'t adding value and helping you grow your business.'
    },
    {
      title: 'You should own your customer relationships',
      description: 'One of the worst parts of tech is how you get separated from your own customers. If you ever decide to leave, you get to bring your customers with you. Always.'
    }
  ];

  return (
    <section className="principles-section">
      <div className="container">
        <motion.h2 
          className="section-title"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={inViewViewport}
        >
          Three beliefs that guide our company
        </motion.h2>

        <motion.p 
          className="section-subtitle"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          viewport={inViewViewport}
        >
          Understand the principles that guide our decisions
        </motion.p>

        <motion.div 
          className="principles-grid"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={inViewViewport}
        >
          {principles.map((principle, idx) => (
            <motion.div 
              key={idx} 
              className="principle-card"
              whileHover={{ y: -8 }}
            >
              <div className="principle-number">{idx + 1}</div>
              <h3>{principle.title}</h3>
              <p>{principle.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default PrinciplesSection;
